import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserManager } from 'src/app/Services/UserManager/user-manager';
import { Subject } from 'rxjs';
import { Profile } from 'src/app/Models/profile.interface';
import _ from 'lodash';
import { transition, state, style, animate, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireDatabase } from '@angular/fire/database';
@Component({
  selector: 'app-instructor-registration',
  templateUrl: './instructor-registration.component.html',
  styleUrls: ['./instructor-registration.component.css', '../lesson-blocks/lesson-blocks.component.css'],
  animations: [
    trigger('display',[
      state('void', style({
          opacity: 0,
          height: 0,
          display: 'none'
      })),
      state('show', style({
          opacity: 1
      })),
      transition('* => *', animate('200ms ease-in-out'))
    ]),
    trigger(
      'item', [
        transition(':enter', [
          style({height: 0, transform: 'scale(0)', opacity: 0}),
          animate('300ms', style({height: '*', transform: 'scale(1)', opacity: 1}))
        ]),
        transition(':leave', [
          style({height: '*', transform: 'scale(1)', opacity: 1}),
          animate('100ms', style({height: 0, transform: 'scale(0)', opacity: 0}))
        ])
      ])

  ]
})
export class InstructorRegistrationComponent implements OnInit, OnDestroy {
  profile: Profile
  leaving = new Subject()
  firstname;
  lastname;
  city;
  country;
  email;
  password;

  orgId;
  invitationId;
  constructor(
    private route: ActivatedRoute,
    private db: AngularFireDatabase,
    private router: Router,
    private um: UserManager) {
      this.orgId = this.route.snapshot.paramMap.get('orgId')
       this.invitationId = this.route.snapshot.paramMap.get('invitationId')
     }

  ngAfterViewInit(){
    this.setup()
  }
    

  setup = async () => {
    // get the invitation object
    setTimeout(() => {
      this.um.getProfileSubject()
        .takeUntil(this.leaving)
        .subscribe(profile => {
          if(!profile){
            this.um.openSignUp()
          } else {
            // update the user profile here
            if(!_.isEqual(this.profile, profile)){
              this.profile = profile
            }

            this.db.object(`InvitationResponses/${this.orgId}/${this.invitationId}`).set(profile.email)
            this.router.navigate(['/my-school'])
            // probably show some updating symbol here
            // wait for backend to do its thing
          }
          
        }
      )} ,1000)
   }


  ngOnInit(): void {
  }

  ngOnDestroy():void{
    this.leaving.next(null)
  }

}
